import { render, staticRenderFns } from "./IdInputDialog.vue?vue&type=template&id=19e12218"
import script from "./IdInputDialog.vue?vue&type=script&lang=ts"
export * from "./IdInputDialog.vue?vue&type=script&lang=ts"
import style0 from "./IdInputDialog.vue?vue&type=style&index=0&id=19e12218&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FieldInput: require('/builds/project/wyffest/frontend/components/field/FieldInput.vue').default,AppBtn: require('/builds/project/wyffest/frontend/components/app/AppBtn.vue').default})
